import React, { useEffect, useRef, useState } from 'react';
import { cn } from '../../utils/cn';
import styles from './CyberReveal.module.css';

export default function CyberReveal({
  as: Element = 'div',
  children,
  className,
  delay = 0,
  variant = 'scan',
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setVisible(true);
        observer.unobserve(entry.target);
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.16 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Element
      ref={ref}
      className={cn(
        styles.reveal,
        styles[variant],
        visible && styles.visible,
        className
      )}
      style={{ '--cyber-reveal-delay': `${delay}ms` }}
    >
      {children}
    </Element>
  );
}
